import { render } from "./ButtonClose.vue?vue&type=template&id=68e1ea59"
import script from "./ButtonClose.vue?vue&type=script&lang=js"
export * from "./ButtonClose.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__